import "./src/styles/global.css"
import "./src/styles/common.css"

import React, { Suspense } from "react"
import { NotificationProvider } from "./src/lib/common/notification"
import { ConfigProvider, Spin } from 'antd';
import jaJP from 'antd/lib/locale/ja_JP';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Loading3QuartersOutlined } from '@ant-design/icons';
import TagManager from 'react-gtm-module';
import { useLoadingStore } from "./src/lib/store/loadingStore";

const SuspenseLoading = () => (
  <Spin
    spinning={true}
    indicator={<Loading3QuartersOutlined spin />}
    size="large"
    fullscreen={true}
  />
);

// QueryClientのインスタンスを作成
const queryClient = new QueryClient();

export const wrapRootElement = ({ element }) => {
  // return (
  //   <SuspenseLoading />
  // );
  return (
    <Suspense fallback={<SuspenseLoading />}>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider
          locale={jaJP}
          theme={{
            token: {
              fontFamily: "'Noto Sans CJK JP', sans-serif",
              fontSize: '1em',
            },
            hashed: false,
          }}
        >
          <NotificationProvider>
            {element}
          </NotificationProvider>
        </ConfigProvider>
      </QueryClientProvider>
    </Suspense>
  );
};

// wrapPageElement は不要（AppLayoutで認証を管理）

// Google Tag Manager の初期化
// 実行タイミング: ブラウザでアプリが起動した直後（最初の1回のみ）
export const onClientEntry = () => {
  const gtmId1 = process.env.GATSBY_GTM_ID1;
  const gtmId2 = process.env.GATSBY_GTM_ID2;
  if (gtmId1) {
    TagManager.initialize({ gtmId: gtmId1 });
  }
  if (gtmId2) {
    TagManager.initialize({ gtmId: gtmId2 });
  }
};

// ページ遷移ごとにdataLayerにpushする
// 実行タイミング: ページ遷移が完了するたび（初回表示 + すべてのページ遷移時）
// ページ遷移の「描画前」にローディング状態をリセット
// （前ページの表示・粒子ローダーを引き継がず、新ページで一瞬も表示させない）
// 実行タイミング: すべての遷移・戻る/進むの直前（初回表示時は発火しない＝初期値のままでOK）
export const onPreRouteUpdate = () => {
  useLoadingStore.setState({ isLoading: false, variant: 'default' });
};

export const onRouteUpdate = ({ location }) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'pageview',
      page: location.pathname + location.search
    });
  }
};
